export default function ({ ...props }) {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.7578 21.5527H23.6807M14.7578 31.3765H23.6807M27.7989 21.5527H36.7218M14.7578 26.5974H23.6807M27.7989 31.7179V27.2645C27.7989 26.8961 28.1062 26.5974 28.4853 26.5974H36.7218"
                stroke="#E7BD7C"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M43.4803 25.789C43.4803 35.6136 35.5378 43.5779 25.7401 43.5779C15.9425 43.5779 8 35.6136 8 25.789C8 15.9644 15.9425 8 25.7401 8C35.5378 8 43.4803 15.9644 43.4803 25.789Z"
                fill="#FDF6E8"
                stroke="url(#paint0_linear_289_16171)"
                strokeWidth="2"
            />
            <path
                d="M19.2505 21.5724L29.5633 17.3807C30.079 17.1711 30.6665 17.4229 30.8704 17.9408L32.3 21.5724M22.8495 25.863H25.5505M22.8495 28.6062H29.1505M35 24.3157V22.5724C35 22.0201 34.5523 21.5724 34 21.5724H18C17.4477 21.5724 17 22.0201 17 22.5724V24.3157C18.3495 24.3157 19.7 25.2298 19.7 27.0589C19.7 28.8881 18.3505 29.8022 17 29.8022V31.5454C17 32.0977 17.4477 32.5454 18 32.5454H34C34.5523 32.5454 35 32.0977 35 31.5454V29.8022C33.6505 29.8022 32.3 28.4301 32.3 26.8299C32.3 25.2298 33.6505 24.3157 35 24.3157Z"
                stroke="url(#paint1_linear_289_16171)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M43.4803 26.789C43.4803 36.6136 35.5378 44.5779 25.7401 44.5779C15.9425 44.5779 8 36.6136 8 26.789C8 16.9644 15.9425 9 25.7401 9C35.5378 9 43.4803 16.9644 43.4803 26.789Z"
                fill="#FDF6E8"
                stroke="url(#paint2_linear_289_16171)"
                strokeWidth="2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.0281 24.8674H30.3784C30.7217 24.8674 31 25.161 31 25.5231C31 25.6428 30.969 25.7602 30.9102 25.8626L24.6897 36.71C24.5268 36.994 24.1765 37.085 23.9072 36.9131C23.7025 36.7824 23.5969 36.5307 23.6431 36.2829L24.9724 29.1447H20.6216C20.2783 29.1447 20 28.8511 20 28.4889C20 28.3693 20.031 28.252 20.0896 28.1497L26.3112 17.2903C26.474 17.0061 26.8243 16.915 27.0936 17.0868C27.2984 17.2174 27.4041 17.4691 27.358 17.7169L26.0281 24.8674Z"
                stroke="url(#paint3_linear_289_16171)"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_289_16171" x1="25.7401" y1="8" x2="25.7401" y2="43.5779" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCDA98" />
                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
                <linearGradient id="paint1_linear_289_16171" x1="34" y1="21.4199" x2="20" y2="31.9199" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="0.625003" stopColor="#CC9856" />
                    <stop offset="1" stopColor="#C28A48" />
                </linearGradient>
                <linearGradient id="paint2_linear_289_16171" x1="25.7401" y1="9" x2="25.7401" y2="44.5779" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCDA98" />
                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
                <linearGradient id="paint3_linear_289_16171" x1="25.5" y1="17" x2="25.5" y2="37" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="1" stopColor="#CF9E5C" />
                </linearGradient>
            </defs>
        </svg>
    );
}
